import { render, staticRenderFns } from "./NewForgotPassword.vue?vue&type=template&id=3f704d22&scoped=true"
import script from "./NewForgotPassword.vue?vue&type=script&lang=js"
export * from "./NewForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./NewForgotPassword.vue?vue&type=style&index=0&id=3f704d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f704d22",
  null
  
)

export default component.exports